import { MessageService } from '@services/message.service';
import { Component, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import TVBasicService from '@services/tv/basic.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-tv-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.scss']
})
export default class TVPlayerComponent implements OnInit, OnDestroy {

  list = {
  };

  on = {
    match_id: null,
    tvlink: null,
    loading: true,
  };

  constructor(
    private messageS: MessageService,
    private route: ActivatedRoute,
    private tvS: TVBasicService,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2
  ) {

  }

  ngOnInit() {
    // Set body styles
    this.renderer.setStyle(document.body, 'background-color', '#151515');

    this.route.queryParamMap.subscribe(params => {
      this.on.match_id = +params.get('match_id');
      if (this.on.match_id) {
        this.registerTv()
      } else {
        this.message('error', 'match_id is required.')
      }
    })
  }

  ngOnDestroy(): void {
    // Remove body styles
    this.renderer.removeStyle(document.body, 'background-color');
  }

  registerTv() {
    this.on.loading = true;
    this.tvS.register(this.on)
      .subscribe(res => {
        if (!res.data) {
          this.on.loading = false;
          return this.message('error', 'Failed to load from the source.')
        }
        this.on.tvlink = res.data;
        console.log('this.on.tvlink ', this.on.tvlink);
        this.on.loading = false;
      }, err => {
        this.message('error', 'Failed to load.')
        this.on.loading = false;
      })
  }

  message(type, message) {
    alert(message)
  }
}
